<template>
  <div>
    <b-container>
      <div class="mt-4 d-lg-flex justify-content-between">
        <div class="statCard yellow">
          <span class="statNumber colorSubTitleCard">{{ totalUser }}</span>
          <span class="colorTitleCard">Utilisateurs</span>
        </div>
        <div class="statCard green mt-2 mt-lg-0">
          <span class="statNumber colorSubTitleCard">{{ totalCount }}</span>
          <span class="colorTitleCard">Questionnaires</span>
        </div>
      </div>
      <div class="mt-4 d-flex align-items-start justify-content-between">
        <div>
          <h1 class="page-title">{{ $t('Questionnaire') }}</h1>
          <h2 class="page-subtitle">{{ $t('Total') }} : {{ totalCount }}</h2>
        </div>
      </div>

      <b-card class="mt-2 mb-4 shadow-sm">

        <b122-table
          ref="B122TableQuestionnaire"
          identifier="B122TableQuestionnaire"
          init-b122-table-url="/questionnaire/initB122Table"
          get-b122-table-results-url="/questionnaire/getB122TableResults"
          :fields="tableFields"
          @setTotalCount="setTotalCount"
          :downloadOnly="true"
        >

          <template #cell(user.firstName)="data">
            <b-link @click="goToQuestionnaire(data)">{{ data.value }}</b-link>
          </template>

          <template #cell(actions)="row">
            <div class="actions-container text-right">
              <button class="action-btn" @click="clickOnDownloadBtn(row)">
                <download-icon size="18"/>
              </button>
              <button class="action-btn" @click="clickOnSendMailBtn(row)">
                <send-icon size="18"/>
              </button>
            </div>
          </template>

        </b122-table>
      </b-card>

      <b-modal
        :visible="isLoading"
        title="Chargement en cours"
        no-close-on-esc
        no-close-on-backdrop
        hide-header-close
        hide-footer
      >
        <div class="d-flex justify-content-center">
          <b-spinner/>
        </div>
      </b-modal>
    </b-container>
  </div>
</template>

<script>

import B122Table from "../../components/b122/B122Table";
import api from '../../services/api';

export default {

  name: 'QuestionnaireIndex',

  components: {
    B122Table
  },

  data() {
    return {
      questionnaireSearch: this.$route.params.userFullName,
      isLoading: false,
      totalCount: 0,
      totalUser: 0,
      tableFields: [
        {
          label: this.$i18n.t('user.FirstName'),
          key: "user.firstName",
          sortable: true
        },
        {
          label: this.$i18n.t('user.LastName'),
          key: "user.lastName",
          sortable: true
        },
        {
          label: this.$i18n.t('ID'),
          key: "patientId",
          sortable: true
        },
        {
          label: this.$i18n.t('questionnaire.DateExamen'),
          key: "dateExamen",
          sortable: true,
          formatter: function (value, key, item) {
            return new Date(value).toLocaleDateString('fr-FR');
          }
        },
        {
          label: "",
          key: "actions"
        }
      ],
    }
  },

  mounted() {
    this.fetchTotalUser();
  },

  methods: {

    fetchTotalUser() {
      api.get(`/user/getTotalUser`)
        .then(response => {
          this.totalUser = response.data.totalUser || 0
        })
    },

    setTotalCount(totalCount) {
      this.totalCount = totalCount
    },

    clickOnSendMailBtn(row){
      if(confirm('Envoyer le questionnaire par mail ?')){
        var data = new FormData();
        data.append('questionnaireId', row.item.id)

        api({
          method: 'POST',
          url: '/questionnaire/resendMailPDF',
          data: data
        })
          .then(response => {
            this.mailSuccessToast(row.item.toStringValue)
          }).catch((error) => {
          this.errorToast("L'envoi de mail n'est pas disponible", error.response.data.message)
        });
      }
    },

    clickOnDownloadBtn(row) {
      this.isLoading = true;

      var data = new FormData();
      data.append('questionnaireId', row.item.id)

      api({
        method: 'POST',
        url: '/questionnaire/downloadPdf',
        data: data
      })
      .then(async response => {
        //--------- DOWNLOAD -----------
        let a = document.createElement('a');
        if (window.URL && window.Blob && ('download' in a) && window.atob) {
          let blob = this.base64ToBlob(response.data.base64, 'application/pdf');
          let url = window.URL.createObjectURL(blob);
          a.href = url;
          a.download = response.data.fileName;
          a.click();
          window.URL.revokeObjectURL(url);

          this.isLoading = false
          //OK
          this.successToast(row.item.toStringValue)
        }
      }).catch((error) => {
        this.errorToast("Le document ne peut pas être téléchargé", error.response.data.message)
      });

    },

    base64ToBlob: function (base64, mimetype, slicesize) {
      if (!window.atob || !window.Uint8Array) {
        // The current browser doesn't have the atob function. Cannot continue
        return null;
      }
      mimetype = mimetype || '';
      slicesize = slicesize || 512;
      let bytechars = atob(base64);
      let bytearrays = [];
      for (let offset = 0; offset < bytechars.length; offset += slicesize) {
        let slice = bytechars.slice(offset, offset + slicesize);
        let bytenums = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          bytenums[i] = slice.charCodeAt(i);
        }
        let bytearray = new Uint8Array(bytenums);
        bytearrays[bytearrays.length] = bytearray;
      }
      return new Blob(bytearrays, {type: mimetype});
    },

    //go to questionnaire ? or show patient ? //naming todo ??
    goToQuestionnaire(data) {
      this.$router.push({
        name: 'UserShow',
        params: {
          userId: data.item.user.id
        }
      })
    },

    successToast(questionnaireName) {
      this.$bvToast.toast(this.$i18n.t('Questionnaire') + ' "' + questionnaireName + '" ' + this.$i18n.t('downloaded'), {
        autoHideDelay: 2000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true
      })
    },

    mailSuccessToast(questionnaireName) {
      this.$bvToast.toast(this.$i18n.t('Questionnaire') + ' "' + questionnaireName + '" ' + this.$i18n.t('sent'), {
        autoHideDelay: 2000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true
      })
    },

    errorToast(title, message) {
      this.$bvToast.toast(message, {
        title: title,
        autoHideDelay: 20000,
        toaster: 'b-toaster-bottom-right'
      })
    }

  }
}
</script>

<style scoped>
.statCard {
  width: 48%;
  padding: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: var(--main-white);
  font-size: var(--title-level-one-font-size);
  font-weight: bold;
  word-break: break-word;
  flex-direction: row;
  border-radius: 10px;
}

@media (max-width: 992px) {
  .statCard {
    width: 100%;
  }
}

.statNumber {
  font-size: 36px;
}

.colorTitleCard {
  margin-top: auto;
  color: var(--secondary-text-color);
  font-weight: bold;
}

.colorSubTitleCard {
  color: var(--secondary-text-color);
}

.green {
  background-color: var(--secondary-color);
}

.yellow {
  background-color: var(--main-color);
}
</style>



// WEBPACK FOOTER //
// src/views/questionnaire/QuestionnaireIndex.vue